var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "vehicle-stock-rep-note-model",
        title: _vm.getTitle(),
        "no-fade": "",
        size: "lg"
      },
      on: {
        change: _vm.onModalChange,
        hide: _vm.onModalChange,
        show: _vm.onModalChange
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-btn",
                {
                  on: {
                    click: function($event) {
                      _vm.modalOpen = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  on: {
                    click: function($event) {
                      return _vm.saveNote()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "form-group inline-label" }, [
          _c("label", { attrs: { for: "vehicle-stock-rep-note" } }, [
            _vm._v("Message")
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.note,
                expression: "note"
              }
            ],
            ref: "message",
            attrs: { id: "vehicle-stock-rep-note" },
            domProps: { value: _vm.note },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.note = $event.target.value
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f7fe4ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f7fe4ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/VehicleStockRepNote.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8f7fe4ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/VehicleStockRepNote.vue
// module chunks = 0